import React from 'react';
import Feedback from 'react-bootstrap/Feedback';
import { useLocalization } from '../../../contexts/LocalizationContext';

export default function ValidationFeedback({ errors, ...props }) {
  const { localize } = useLocalization();

  if (!Array.isArray(errors) || !errors.length) {
    return null;
  }

  const feedback = errors.map((error) => {
    switch(error.type) {
      case 'errorMessage':
        if (!error.message) break;
        return localize(error.message);

      case 'type':
        if (error.params?.type === 'string') {
          return localize('validation.feedback.required');
        }
        return localize(`validation.feedback.type.${error.params.type}`);

      case 'format':
        return localize(`validation.feedback.format.${error.params.format}`);

      case 'minLength':
      case 'maxLength':
      case 'minimum':
      case 'maximum':
        return localize(`validation.feedback.${error.type}`, { values: error.params });

      case 'notEmpty':
        return localize('validation.feedback.required');

      case 'unique':
      case 'unique violation':
        return localize('validation.feedback.unique');
        
      default:
        return localize('validation.feedback.invalid');
    }
  }).filter(Boolean);

  return (
    <Feedback type='invalid' {...props}>
      {feedback.length > 0 &&  feedback.join('. ') + '.'}
    </Feedback>
  );
}